<div class="marquee marquee-danger">
  <i class="far fa-exclamation-triangle marquee-icon"></i>
  <h1 class="marquee-heading">{{ errorTitle }}</h1>
  <h2 class="marquee-message">{{ errorMessage }}</h2>
  <!-- <button type="button" class="btn btn-primary marquee-primary-action">...</button>-->
  <a [href]="urlLogout" class="marquee-secondary-action">Please log back in via The Portal</a>
</div>
